import { EventState } from 'stageclip-common';

export function eventStateAllowForParticipantUploads(eventState: EventState) {
  return eventState !== EventState.Complete && eventState !== EventState.ReviewNeeded;
}
